import type { RegionTrailItem } from "./types/regions";

// Region trail progress for clients (ATL-136). A region counts a trail by the
// sections inside it; payloads that predate the section fields (offline
// caches, prerendered pages) fall back to the old `collected` flag.

export function isRegionTrailDone(t: RegionTrailItem): boolean {
  if (t.sectionsInRegion == null || t.completedInRegion == null) return t.collected;
  return t.sectionsInRegion > 0 && t.completedInRegion >= t.sectionsInRegion;
}

/** "3 of 7 sections in this region", or null when the counts are missing. */
export function regionTrailSectionsLabel(t: RegionTrailItem): string | null {
  const total = t.sectionsInRegion;
  if (total == null || total <= 0) return null;
  const done = Math.min(t.completedInRegion ?? 0, total);
  return `${done} of ${total} ${total === 1 ? "section" : "sections"} in this region`;
}
